import { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../../common/modal'
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

import { floatFilter, focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SelectChargeTypeOpt } from './constants'
import AddandRemoveBtn from '../BookingPage/PickupAndDropoffCharge/AddandRemoveBtn'
import useToken from '../../../helpers/useTokens'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import Lineinput from '../../../common/lineinput'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import LineinputV2 from '../../../common/lineinputV2'

export const CartageSetupModal = ({ branchList = [], isUpdate, headText, closePopup, refreshData }) => {
  const { loginData } = useToken()
  const { intBranchCityID, intBranchID } = { ...loginData }
  const cityList = removeDuplicatesFromArray(branchList, 'CityID')
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)

  const [selSelectChrgType, setSelSelectChrgType] = useState(SelectChargeTypeOpt[0])
  const [showData, setShowData] = useState(false)
  const [branchOpt, setBranchOpt] = useState([])
  const [cityOpt, setCityOpt] = useState([])
  const [selCity, setSelCity] = useState('')
  const [selBranch, setSelBranch] = useState('')
  const [pickupChrg, setPickupChrg] = useState([])
  const [dropOffChrg, setDropOffChrg] = useState([])
  const [pickupChrgKm, setPickupChrgKm] = useState([{ fromKG: 1, toKG: 99999, fromKM: 1, toKm: 9999, fromPer: 0, toPer: 999999, rate: 0 }])
  const [dropOffChrgKm, setDropOffChrgKm] = useState([
    { fromKG: 1, toKG: 99999, fromKM: 1, toKm: 9999, fromPer: 0, toPer: 999999, rate: 0 },
  ])
  const [isPickUpChrg, setIsPickUpChrg] = useState(false)
  const [isDropOffChrg, setIsDropOffChrg] = useState(false)
  const [pickupCharge, setPickupCharge] = useState(0)
  const [dropOffCharge, setDropOffCharge] = useState(0)
  const [isAdditionalCartage, setIsAdditionalCartage] = useState(false)
  const [isForAllBranchs, setIsForAllBranchs] = useState(false)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const tableHeader = [
    { headerName: 'Range Min', headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: 'Range Max', headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: 'Rate', headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: 'Action', headerSx: { minWidth: '25%', textAlign: 'left' } },
  ]
  const tableHeaderKM = [
    { headerName: 'From KG - To KG', headerSx: { minWidth: '27%', textAlign: 'right' } },
    { headerName: 'From KM - To KM', headerSx: { minWidth: '27%', textAlign: 'right' } },
    { headerName: 'Rate Per KG-KM', headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: 'Action', headerSx: { minWidth: '20%', textAlign: 'right' } },
  ]
  useEffect(() => {
    if (intBranchCityID && branchList.length) {
      setCityOpt(cityList)
      const defaultCity = cityList.find((val) => val.CityID === intBranchCityID) || cityList[0]
      if (defaultCity) {
        setSelCity(defaultCity)
        let cityWiseBranch = branchList.filter((val) => val.CityID === defaultCity.CityID)
        setBranchOpt(cityWiseBranch)
        let defaultBranch = cityWiseBranch.find((val) => val.BranchID === intBranchID) || cityWiseBranch[0]
        if (defaultBranch) {
          setSelBranch(defaultBranch)
        }
      }
    }
  }, [branchList, intBranchCityID])

  useEffect(() => {
    focusElemnt('Select_City')
  }, [])
  const handleIsPickUpChrg = (event) => {
    if (event.target.checked && pickupChrg.length === 0 && showData) {
      setPickupChrg([selSelectChrgType.id === 1 ? { RangeMin: 1, RangeMax: 99999, Rate: 0 } : { RangeMin: 1, RangeMax: 9999, Rate: 0 }])
    }
    setIsPickUpChrg(!isPickUpChrg)
  }
  const handleIsDropOffChrg = (event) => {
    if (event.target.checked && dropOffChrg.length === 0 && showData) {
      setDropOffChrg([selSelectChrgType.id === 1 ? { RangeMin: 1, RangeMax: 99999, Rate: 0 } : { RangeMin: 1, RangeMax: 9999, Rate: 0 }])
    }
    setIsDropOffChrg(!isDropOffChrg)
  }
  //PickUp charge
  const handlePickUpChrg = (event, field, index) => {
    if (field === 'RangeMax' && isUpdate && parseInt(event.target.value) > (selSelectChrgType.id === 1 ? 9999 : 99999)) {
      setAlert({
        show: true,
        msg: `Range Max should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`,
        nextId: `pickUpRangeMax-${index}`,
      })
      resetPickUpChrg(event, field, index)
    } else if (
      field === 'RangeMax' &&
      isUpdate &&
      event.target.value !== '' &&
      (event.target.value !== '' ? parseInt(event.target.value) <= pickupChrg[index].RangeMin : true)
    ) {
      setAlert({ show: true, msg: `Range Max should greater than Range Min`, nextId: `pickUpRangeMax-${index}` })
      resetPickUpChrg(event, field, index)
    } else if (field === 'RangeMin' && event.target.value !== '') {
      if (parseInt(event.target.value) <= pickupChrg[index - 1].RangeMin) {
        setAlert({ show: true, msg: `Value must be greater than previous value`, nextId: `pickUpRangeMin-${index}` })
        resetPickUpChrg(event, field, index)
      } else if (
        pickupChrg.length - 1 > index
          ? pickupChrg[index + 1]?.RangeMin !== ''
            ? parseInt(event.target.value) >= pickupChrg[index + 1]?.RangeMin
            : false
          : false
      ) {
        setAlert({ show: true, msg: `Value must be less than next value`, nextId: `pickUpRangeMin-${index}` })
        resetPickUpChrg(event, field, index)
      } else if (parseInt(event.target.value) >= (selSelectChrgType.id === 1 ? 9999 : 99999)) {
        setAlert({
          show: true,
          msg: `Range Min should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`,
          nextId: `pickUpRangeMin-${index}`,
        })
        resetPickUpChrg(event, field, index)
      } else if (
        isUpdate &&
        (index === 3 && pickupChrg[index].RangeMax !== '' ? parseInt(event.target.value) > pickupChrg[index].RangeMax : false)
      ) {
        setAlert({ show: true, msg: `Value must be less than Range Max`, nextId: `pickUpRangeMin-${index}` })
        resetPickUpChrg(event, field, index)
      }
    }
  }
  const resetPickUpChrg = (event, field, index) => {
    let oldData = [...pickupChrg.map((val, i) => (i === index ? { ...val, [field]: '' } : val))]
    setPickupChrg(oldData)
    if (field === 'RangeMin') {
      oldData[index - 1].RangeMax = ''
    }
    setPickupChrg(oldData)
  }
  const handleChangePickUpChrg = (event, field, index) => {
    const regex = new RegExp('^[0-9""]*$')
    if (regex.test(event.target.value)) {
      let oldData = [
        ...pickupChrg.map((val, i) =>
          i === index ? { ...val, [field]: event.target.value !== '' ? parseInt(event.target.value) : event.target.value } : val
        ),
      ]
      if (field === 'RangeMin') {
        oldData[index - 1].RangeMax = event.target.value !== '' ? event.target.value - 1 : event.target.value
      }
      setPickupChrg(oldData)
    }
  }
  const handleAddPickUpChrg = (index) => {
    let newData = { RangeMin: '', RangeMax: pickupChrg[index].RangeMax, Rate: 0 }
    let newArr = [...pickupChrg.map((val, i) => (i === index ? { ...val, RangeMax: '' } : val))]
    newArr.splice(index + 1, 0, newData)
    setPickupChrg(newArr)
  }
  const handleRemovePickUpChrg = (index) => {
    let oldRangeMax = pickupChrg[index].RangeMax
    let newData = pickupChrg.filter((val, i) => i !== index)
    setPickupChrg([...newData.map((val, i) => (i === index - 1 ? { ...val, RangeMax: oldRangeMax } : val))])
  }
  //DropOff charge
  const handleDropOffChrg = (event, field, index) => {
    if (field === 'RangeMax' && isUpdate && parseInt(event.target.value) > (selSelectChrgType.id === 1 ? 9999 : 99999)) {
      setAlert({
        show: true,
        msg: `Range Max should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`,
        nextId: `dropOffMax-${index}`,
      })
      resetDropOffChrg(event, field, index)
    } else if (
      field === 'RangeMax' &&
      isUpdate &&
      event.target.value !== '' &&
      (event.target.value !== '' ? parseInt(event.target.value) <= dropOffChrg[index].RangeMin : true)
    ) {
      setAlert({ show: true, msg: `Range Max should greater than Range Min`, nextId: `dropOffMax-${index}` })
      resetDropOffChrg(event, field, index)
    } else if (field === 'RangeMin' && event.target.value !== '') {
      if (parseInt(event.target.value) <= dropOffChrg[index - 1].RangeMin) {
        setAlert({ show: true, msg: `Value must be greater than previous value`, nextId: `dropOffMin-${index}` })
        resetDropOffChrg(event, field, index)
      } else if (
        dropOffChrg.length - 1 > index
          ? dropOffChrg[index + 1]?.RangeMin !== ''
            ? parseInt(event.target.value) >= dropOffChrg[index + 1]?.RangeMin
            : false
          : false
      ) {
        setAlert({ show: true, msg: `Value must be less than next value`, nextId: `dropOffMin-${index}` })
        resetDropOffChrg(event, field, index)
      } else if (parseInt(event.target.value) >= (selSelectChrgType.id === 1 ? 9999 : 99999)) {
        setAlert({
          show: true,
          msg: `Range Min should not exceed ${selSelectChrgType.id === 1 ? 9999 : 99999}`,
          nextId: `dropOffMin-${index}`,
        })
        resetDropOffChrg(event, field, index)
      } else if (
        isUpdate &&
        (index === 3 && dropOffChrg[index].RangeMax !== '' ? parseInt(event.target.value) > dropOffChrg[index].RangeMax : false)
      ) {
        setAlert({ show: true, msg: `Value must be less than Range Max`, nextId: `dropOffMin-${index}` })
        resetDropOffChrg(event, field, index)
      }
    }
  }
  const handleChangeDropOffChrg = (event, field, index) => {
    const regex = new RegExp('^[0-9""]*$')
    if (regex.test(event.target.value)) {
      let oldData = [
        ...dropOffChrg.map((val, i) =>
          i === index ? { ...val, [field]: event.target.value !== '' ? parseInt(event.target.value) : event.target.value } : val
        ),
      ]
      if (field === 'RangeMin') {
        oldData[index - 1].RangeMax = event.target.value !== '' ? event.target.value - 1 : event.target.value
      }
      setDropOffChrg(oldData)
    }
  }
  const resetDropOffChrg = (event, field, index) => {
    let oldData = [...dropOffChrg.map((val, i) => (i === index ? { ...val, [field]: '' } : val))]
    if (field === 'RangeMin') {
      oldData[index - 1].RangeMax = ''
    }
    setDropOffChrg(oldData)
  }

  const handleAddDropOffChrg = (index) => {
    let newData = { RangeMin: '', RangeMax: dropOffChrg[index].RangeMax, Rate: 0 }
    let newArr = [...dropOffChrg.map((val, i) => (i === index ? { ...val, RangeMax: '' } : val))]
    newArr.splice(index + 1, 0, newData)
    setDropOffChrg(newArr)
  }
  const handleRemoveDropOffChrg = (index) => {
    let oldRangeMax = dropOffChrg[index].RangeMax
    let newData = dropOffChrg.filter((val, i) => i !== index)
    setDropOffChrg([...newData.map((val, i) => (i === index - 1 ? { ...val, RangeMax: oldRangeMax } : val))])
  }
  const handlePickupChrgKm = (event, field, index) => {
    let oldData = [...pickupChrgKm.map((val, i) => (i === index ? { ...val, [field]: event.target.value } : val))]
    if (field === 'fromKG') {
      oldData[index - 1].toKG = event.target.value - 1
    }
    if (field === 'fromKM') {
      oldData[index - 1].toKm = event.target.value - 1
    }
    setPickupChrgKm(oldData)
  }
  const handleAddPickUpChrgKm = (index) => {
    let newRowData = { fromKG: '', toKG: pickupChrgKm[index].toKG, fromKM: '', toKm: pickupChrgKm[index].toKm, rate: 0 }
    let newArr = [...pickupChrgKm.map((val, i) => (i === index ? { ...val, toKG: '', toKm: '' } : val))]
    newArr.splice(index + 1, 0, newRowData)
    setPickupChrgKm(newArr)
  }
  const handleRemovePickUpChrgKm = (index) => {
    let oldToKG = pickupChrgKm[index].toKG
    let oldToKm = pickupChrgKm[index].toKm
    let newData = pickupChrgKm.filter((val, i) => i !== index)
    setPickupChrgKm([...newData.map((val, i) => (i === index - 1 ? { ...val, toKG: oldToKG, toKm: oldToKm } : val))])
  }

  const handleDropOffChrgKm = (event, field, index) => {
    let oldData = [...dropOffChrgKm.map((val, i) => (i === index ? { ...val, [field]: event.target.value } : val))]
    if (field === 'fromKG') {
      oldData[index - 1].toKG = event.target.value - 1
    }
    if (field === 'fromKM') {
      oldData[index - 1].toKm = event.target.value - 1
    }
    setDropOffChrgKm(oldData)
  }
  const handleAddDropOffChrgKm = (index) => {
    let newRowData = { fromKG: '', toKG: dropOffChrgKm[index].toKG, fromKM: '', toKm: dropOffChrgKm[index].toKm, rate: 0 }
    let newArr = [...dropOffChrgKm.map((val, i) => (i === index ? { ...val, toKG: '', toKm: '' } : val))]
    newArr.splice(index + 1, 0, newRowData)
    setDropOffChrgKm(newArr)
  }
  const handleRemoveDropOffChrgKm = (index) => {
    let oldToKG = dropOffChrgKm[index].toKG
    let oldToKm = dropOffChrgKm[index].toKm
    let newData = dropOffChrgKm.filter((val, i) => i !== index)
    setDropOffChrgKm([...newData.map((val, i) => (i === index - 1 ? { ...val, toKG: oldToKG, toKm: oldToKm } : val))])
  }
  const hasEmptyValue = (array, properties) => {
    return array.some((obj) => {
      return properties.some((prop) => {
        const value = obj[prop]
        return value === '' || value == null
      })
    })
  }
  const disableBtn = () => {
    return (
      (isPickUpChrg ? hasEmptyValue(pickupChrg, ['RangeMin', 'RangeMax', 'Rate']) : false) ||
      (isDropOffChrg ? hasEmptyValue(dropOffChrg, ['RangeMin', 'RangeMax', 'Rate']) : false)
    )
  }
  const resetPickAndDrop = (id) => {
    setShowData(false)
    setIsPickUpChrg(false)
    setIsDropOffChrg(false)
    if (id === 1) {
      setPickupChrg([])
      setDropOffChrg([])
    } else {
      setPickupChrg([])
      setDropOffChrg([])
    }
  }
  const handleChrgType = (value) => {
    setSelSelectChrgType(value)
    resetPickAndDrop(value.id)
  }
  const getPickupDropoffChargeValue = () => {
    const body = {
      CompanyID: loginData?.intCompanyID,
      BranchID: selBranch?.BranchID,
      ChargeTypeID: selSelectChrgType.id,
    }
    resetPickAndDrop(selSelectChrgType.id)
    
    GetRequest(urls.pickupDropoffCartageSlab, body)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!isUpdate && (res.Data.Table.length > 0 || res.Data.Table1.length > 0 || res.Data.Table2.length > 0)) {
          throw new Error('Pickup/Dropoff Cartage already updated for Selected Branch.')
        }
        setShowData(true)
        if (res.Data.Table.length) {
          const data = res.Data.Table[0]
          setIsPickUpChrg(data.IsPickupCartageEnabled === 1)
          setIsDropOffChrg(data.IsDropoffCartageEnabled === 1)
          setIsAdditionalCartage(data.IsAdditionalCartage === 1)
          setPickupCharge(data.AdditionalPickupCartage)
          setDropOffCharge(data.AdditionalDropoffCartage)
        }
        if (res.Data.Table1.length) {
          setPickupChrg(res.Data.Table1)
        }
        if (res.Data.Table2.length) {
          setDropOffChrg(res.Data.Table2)
        }
        if (selSelectChrgType.id === 4 && !res.Data.Table2.length && !res.Data.Table1.length) {
          const dummy = { Rate: 0, RangeMin: 1, RangeMax: 999999 }
          setPickupChrg([dummy])
          setDropOffChrg([dummy])
        }
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: 'Select_City' })
      })
  }
  const close = () => {
    setAlert({ show: false, msg: '', nextId: '' })
    closePopup()
  }
  const saveAndUpdateCharg = () => {
    const body = {
      CompanyID: loginData?.intCompanyID,
      BranchID: selBranch?.BranchID,
      UserID: loginData?.intUserID,
      ChargeType: selSelectChrgType.id,
      IsPickupCharge: isPickUpChrg ? 1 : 0,
      IsDropOffCharge: isDropOffChrg ? 1 : 0,
      PickupchgQty: pickupChrg.map((val) => `${val.RangeMin}-${val.RangeMax}`).join(','),
      PickupCharges: pickupChrg.map((val) => val.Rate).join(','),
      DropoffchgQty: dropOffChrg.map((val) => `${val.RangeMin}-${val.RangeMax}`).join(','),
      DropoffCharges: dropOffChrg.map((val) => val.Rate).join(','),
      IsAdditionalCharge: isAdditionalCartage ? 1 : 0,
      AdditionalPickupCartage: parseFloat(pickupCharge) || 0,
      AdditionalDropoffCartage: parseFloat(dropOffCharge) || 0,
      IsApplyForAllBranch: isForAllBranchs ? 1 : 0,
    }
    setLoader(true)
    PostRequest(urls.pickupDropoffCartageUpdate, body)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        refreshData()
        setAlert({ show: true, msg: 'Updated Successfully', success: true, nextId: 'Select_City', close })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: 'Select_City' })
      })
      .finally(() => setLoader(false))
  }
  return (
    <Modal
      headTxt={headText}
      width={selSelectChrgType?.id !== 3 ? '80%' : '90%'}
      updateModal={closePopup}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Grid container sx={{ display: 'flex', padding: '12px 8px 4px 8px' }}>
        <Grid item md={3.6}>
          <Item>
            <DropDownOA
              id={'Select_City'}
              label={'Select City'}
              width="100%"
              prevId={'saveAndUpdateBtn'}
              nextId={'Select_Branch'}
              defaultvalue={selCity?.CityName || selCity}
              data={cityOpt || []}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setSelCity(val)
                resetPickAndDrop(selSelectChrgType.id)
                const cityBranchList = branchList.filter((obj) => obj.CityID === val.CityID)
                setBranchOpt(cityBranchList)
                setSelBranch(cityBranchList?.[0] || '')
              }}
            />
          </Item>
        </Grid>
        <Grid item md={3.6}>
          <Item>
            <DropDownOA
              id={'Select_Branch'}
              label={'Select Branch'}
              width="100%"
              prevId={'Select_City'}
              nextId={'Select_Charge_Type'}
              defaultvalue={selBranch?.BranchName || selBranch}
              data={branchOpt || []}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setSelBranch(val)
                resetPickAndDrop(selSelectChrgType.id)
              }}
            />
          </Item>
        </Grid>
        <Grid item md={3.6}>
          <Item>
            <DropDownOA
              id={'Select_Charge_Type'}
              data={SelectChargeTypeOpt || []}
              defaultvalue={selSelectChrgType.name || selSelectChrgType}
              label={'Select Cartage Type'}
              width="100%"
              idKey={`id`}
              onSelect={(val) => handleChrgType(val)}
              dataKey={`name`}
              prevId={'Select_Branch'}
              nextId={'go_btn'}
            />
          </Item>
        </Grid>
        <Grid item md={1.1} sx={{ paddingY: '6px' }}>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'go_btn'}
              style={{ ...sx.fullHeight, ...sx.novp, width: '100%' }}
              onKeyDown={(e) => {
                navigation3(e, 'pickupCharge', 'Select_Charge_Type', () => {})
              }}
              className="btn btn-primary"
              onClick={() => getPickupDropoffChargeValue()}
            >
              GO
            </Button>
          </Item>
        </Grid>
      </Grid>
      <Grid container sx={{ paddingX: '15px', marginBottom: '10px' }}>
        <Grid item sm={12} md={6} sx={{ paddingRight: '8px' }}>
          <Box>
            <FormControlLabel
              control={<Checkbox id={'pickupCharge'} size={'medium'} checked={isPickUpChrg} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600', color: '#444', fontSize: '16px' }}>
                  Pickup Cartage (For 1st Unit)
                </Typography>
              }
              onChange={handleIsPickUpChrg}
              onKeyDown={(e) => {
                navigation3(e, 'dropOffCharge', 'go_btn', () => {})
              }}
            />
          </Box>
          <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px' }}>
            {selSelectChrgType?.id !== 3 ? (
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px 4px !important',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {tableHeader.map((row, index) => {
                      return (
                        <TableCell
                          key={'dsore342le' + index}
                          sx={{
                            ...row.headerSx,
                            backgroundColor: '#DAEDFE',
                            minHeight: '36px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#444',
                          }}
                        >
                          {row.headerName}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isPickUpChrg ? (
                    pickupChrg.map((row, index) => {
                      return (
                        <TableRow key={'dso34-32vm' + index}>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                id={`pickUpRangeMin-${index}`}
                                disabled={index === 0}
                                textAlign={'end'}
                                value={row.RangeMin}
                                onChange={(e) => handleChangePickUpChrg(e, 'RangeMin', index)}
                                onBlur={(e) => handlePickUpChrg(e, 'RangeMin', index)}
                                onKeyDown={(e) => {
                                  navigation3(
                                    e,
                                    isUpdate && index === 3 ? `pickUpRangeMax-${index}` : `pickUpRate-${index}`,
                                    pickupChrg.length >= 4 ? `pickUpRate-${index - 1}` : `addbtn-${index - 1}`,
                                    () => {}
                                  )
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                id={`pickUpRangeMax-${index}`}
                                textAlign={'end'}
                                disabled={isUpdate && index === 3 ? false : true}
                                onChange={(e) => handleChangePickUpChrg(e, 'RangeMax', index)}
                                onBlur={(e) => handlePickUpChrg(e, 'RangeMax', index)}
                                onKeyDown={(e) => {
                                  navigation3(e, `pickUpRate-${index}`, `pickUpRangeMin-${index}`, () => {})
                                }}
                                value={row.RangeMax}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                id={`pickUpRate-${index}`}
                                textAlign={'end'}
                                value={row.Rate}
                                onChange={(e) => handleChangePickUpChrg(e, 'Rate', index)}
                                onBlur={(e) => handlePickUpChrg(e, 'Rate', index)}
                                onKeyDown={(e) => {
                                  navigation3(
                                    e,
                                    pickupChrg.length >= 4
                                      ? index === 3
                                        ? `removebtn-${index}`
                                        : `pickUpRangeMin-${index + 1}`
                                      : `addbtn-${index}`,
                                    index === 0
                                      ? 'dropOffCharge'
                                      : isUpdate && index === 3
                                      ? `pickUpRangeMax-${index}`
                                      : `pickUpRangeMin-${index}`
                                  )
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <AddandRemoveBtn
                              pickUpChrg={true}
                              addRow={handleAddPickUpChrg}
                              removeRow={handleRemovePickUpChrg}
                              index={index}
                              data={pickupChrg}
                              onKeyDownadd={(e) => {
                                navigation3(
                                  e,
                                  pickupChrg.length === 1
                                    ? isDropOffChrg
                                      ? `dropOffRate-0`
                                      : 'saveAndUpdateBtn'
                                    : pickupChrg.length - 1 === index
                                    ? `removebtn-${index}`
                                    : `pickUpRangeMin-${index + 1}`,
                                  `pickUpRate-${index}`,
                                  () => {
                                    if (index === 2) {
                                      handleAddPickUpChrg(index)
                                      focusElemnt(`pickUpRate-${index}`)
                                    }
                                  }
                                )
                              }}
                              onKeyDownRemove={(e) => {
                                navigation3(
                                  e,
                                  isDropOffChrg ? 'dropOffRate-0' : 'saveAndUpdateBtn',
                                  pickupChrg.length >= 4 ? `pickUpRate-${index}` : `addbtn-${index}`,
                                  () => {
                                    if (pickupChrg.length - 1 === index) {
                                      handleRemovePickUpChrg(index)
                                      focusElemnt(`pickUpRate-${index - 1}`)
                                    }
                                  }
                                )
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}
                      >
                        No Result Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            ) : (
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px 4px !important',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {tableHeaderKM.map((row, index) => {
                      return (
                        <TableCell
                          key={'df-3423ss' + index}
                          sx={{
                            ...row.headerSx,
                            backgroundColor: '#DAEDFE',
                            whiteSpace: 'nowrap',
                            minHeight: '36px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#444',
                          }}
                        >
                          {row.headerName}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isPickUpChrg ? (
                    pickupChrgKm.map((row, index) => {
                      return (
                        <TableRow key={'dso323-e' + index}>
                          <TableCell>
                            <Box sx={{ display: 'flex' }}>
                              <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  value={row.fromKG}
                                  disabled={index === 0}
                                  onBlur={(e) => handlePickupChrgKm(e, 'fromKG', index)}
                                />
                              </div>
                              <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput label={''} value={row.toKG} disabled={true} />
                              </div>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex' }}>
                              <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  value={row.fromKM}
                                  disabled={index === 0}
                                  onBlur={(e) => handlePickupChrgKm(e, 'fromKM', index)}
                                />
                              </div>
                              <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput label={''} value={row.toKm} disabled={true} />
                              </div>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput label={''} value={row.rate} onBlur={(e) => handlePickupChrgKm(e, 'rate', index)} />
                            </div>
                          </TableCell>
                          <TableCell>
                            <AddandRemoveBtn
                              addRow={handleAddPickUpChrgKm}
                              removeRow={handleRemovePickUpChrgKm}
                              index={index}
                              data={pickupChrgKm}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}
                      >
                        No Result Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Grid>
        <Grid item sm={12} md={6} sx={{ paddingLeft: '8px' }}>
          <Box>
            <FormControlLabel
              control={<Checkbox id="dropOffCharge" size={'medium'} checked={isDropOffChrg} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600', color: '#444', fontSize: '16px' }}>
                  Dropoff Cartage (For 1st Unit)
                </Typography>
              }
              onChange={handleIsDropOffChrg}
              onKeyDown={(e) => {
                navigation3(
                  e,
                  isDropOffChrg || isPickUpChrg
                    ? isPickUpChrg
                      ? 'pickUpRate-0'
                      : isDropOffChrg
                      ? `dropOffMin-0`
                      : 'saveAndUpdateBtn'
                    : 'saveAndUpdateBtn',
                  'pickupCharge',
                  () => {}
                )
              }}
            />
          </Box>
          <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px' }}>
            {selSelectChrgType?.id !== 3 ? (
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px 4px !important',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {tableHeader.map((row, index) => {
                      return (
                        <TableCell
                          key={'df034s' + index}
                          sx={{
                            ...row.headerSx,
                            backgroundColor: '#DAEDFE',
                            minHeight: '36px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#444',
                          }}
                        >
                          {row.headerName}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isDropOffChrg ? (
                    dropOffChrg.map((row, index) => {
                      return (
                        <TableRow key={'err034' + index}>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                disabled={index === 0}
                                id={`dropOffMin-${index}`}
                                textAlign={'end'}
                                value={row.RangeMin}
                                onChange={(e) => handleChangeDropOffChrg(e, 'RangeMin', index)}
                                onBlur={(e) => handleDropOffChrg(e, 'RangeMin', index)}
                                onKeyDown={(e) => {
                                  navigation3(
                                    e,
                                    isUpdate && index === 3 ? `dropOffMax-${index}` : `dropOffRate-${index}`,
                                    dropOffChrg.length >= 4 ? `dropOffRate-${index - 1}` : `addbtnD-${index - 1}`,
                                    () => {}
                                  )
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                id={`dropOffMax-${index}`}
                                textAlign={'end'}
                                disabled={isUpdate && index === 3 ? false : true}
                                value={row.RangeMax}
                                onChange={(e) => handleChangeDropOffChrg(e, 'RangeMax', index)}
                                onBlur={(e) => handleDropOffChrg(e, 'RangeMax', index)}
                                onKeyDown={(e) => {
                                  navigation3(e, `dropOffRate-${index}`, `dropOffMin-${index}`, () => {})
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput
                                label={''}
                                value={row.Rate}
                                id={`dropOffRate-${index}`}
                                textAlign={'end'}
                                onChange={(e) => handleChangeDropOffChrg(e, 'Rate', index)}
                                onBlur={(e) => handleDropOffChrg(e, 'Rate', index)}
                                onKeyDown={(e) => {
                                  navigation3(
                                    e,
                                    dropOffChrg.length >= 4
                                      ? index === 3
                                        ? `removebtnW-${index}`
                                        : `dropOffMin-${index + 1}`
                                      : `addbtnD-${index}`,
                                    index === 0
                                      ? isPickUpChrg
                                        ? dropOffChrg.length === 1
                                          ? `addbtn-${dropOffChrg.length - 1}`
                                          : `removebtn-${pickupChrg.length - 1}`
                                        : 'dropOffCharge'
                                      : isUpdate && index === 3
                                      ? `dropOffMax-${index}`
                                      : `dropOffMin-${index}`,
                                    () => {}
                                  )
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <AddandRemoveBtn
                              addRow={handleAddDropOffChrg}
                              removeRow={handleRemoveDropOffChrg}
                              index={index}
                              data={dropOffChrg}
                              onKeyDownadd={(e) => {
                                navigation3(
                                  e,
                                  dropOffChrg.length === 1
                                    ? 'saveAndUpdateBtn'
                                    : dropOffChrg.length - 1 === index
                                    ? `removebtnW-${index}`
                                    : `dropOffMin-${index + 1}`,
                                  `dropOffRate-${index}`,
                                  () => {}
                                )
                                if (index === 2) {
                                  handleAddDropOffChrg(index)
                                  focusElemnt(`dropOffRate-${index}`)
                                }
                              }}
                              onKeyDownRemove={(e) => {
                                navigation3(
                                  e,
                                  'saveAndUpdateBtn',
                                  dropOffChrg.length >= 4 ? `dropOffRate-${index}` : `addbtnD-${index}`,
                                  () => {
                                    if (dropOffChrg.length - 1 === index) {
                                      handleRemoveDropOffChrg(index)
                                      focusElemnt(`dropOffRate-${index - 1}`)
                                    }
                                  }
                                )
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}
                      >
                        No Result Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            ) : (
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px 4px !important',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {tableHeaderKM.map((row, index) => {
                      return (
                        <TableCell
                          key={'errepdp_@3' + index}
                          sx={{
                            ...row.headerSx,
                            backgroundColor: '#DAEDFE',
                            whiteSpace: 'nowrap',
                            minHeight: '36px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#444',
                          }}
                        >
                          {row.headerName}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isDropOffChrg ? (
                    dropOffChrgKm.map((row, index) => {
                      return (
                        <TableRow key={'sde3d4' + index}>
                          <TableCell>
                            <Box sx={{ display: 'flex' }}>
                              <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  value={row.fromKG}
                                  disabled={index === 0}
                                  onBlur={(e) => handleDropOffChrgKm(e, 'fromKG', index)}
                                />
                              </div>
                              <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput label={''} value={row.toKG} disabled={true} />
                              </div>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex' }}>
                              <div style={{ paddingRight: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  value={row.fromKM}
                                  disabled={index === 0}
                                  onBlur={(e) => handleDropOffChrgKm(e, 'fromKM', index)}
                                />
                              </div>
                              <div style={{ paddingLeft: '4px' }} className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput label={''} value={row.toKm} disabled={true} />
                              </div>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <div className={'input--wrapper btmSpaceNotRequired'}>
                              <Lineinput label={''} value={row.rate} onBlur={(e) => handleDropOffChrgKm(e, 'rate', index)} />
                            </div>
                          </TableCell>
                          <TableCell>
                            <AddandRemoveBtn
                              addRow={handleAddDropOffChrgKm}
                              removeRow={handleRemoveDropOffChrgKm}
                              index={index}
                              data={dropOffChrgKm}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}
                      >
                        No Result Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Grid>
      </Grid>
      <Divider />
      <Grid container sx={{ paddingX: '10px' }}>
        <Grid item md={10} sx={{ display: 'flex' }}>
          <Item>
            <FormControlLabel
              control={<Checkbox checked={isAdditionalCartage} onChange={(e) => setIsAdditionalCartage(e.target.checked)} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600' }}>
                  Additional Cartage Per Unit
                </Typography>
              }
            />
          </Item>
          <Item className={'input--wrapper btmSpaceNotRequired'}>
            <LineinputV2
              label={'Pickup'}
              value={pickupCharge}
              filter={(w) => floatFilter(w, 2)}
              onBlur={(e) => setPickupCharge(e.target.value)}
            />
          </Item>
          <Item className={'input--wrapper btmSpaceNotRequired'}>
            <LineinputV2
              label={'Dropoff'}
              value={dropOffCharge}
              filter={(w) => floatFilter(w, 2)}
              onBlur={(e) => setDropOffCharge(e.target.value)}
            />
          </Item>
          <Item>
            <FormControlLabel
              control={<Checkbox checked={isForAllBranchs} onChange={(e) => setIsForAllBranchs(e.target.checked)} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600' }}>
                  Apply this for All Branches
                </Typography>
              }
            />
          </Item>
        </Grid>
        <Grid
          item
          md={2}
          sx={{ paddingRight: '6px', paddingY: '8px', display: 'flex', justifyContent: 'end' }}
          className="disabled-wrapper"
        >
          <Button
            variant="contained"
            id={'saveAndUpdateBtn'}
            disabled={disableBtn() || !showData}
            style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }}
            className="btn btn-primary"
            onKeyDown={(e) => {
              navigation3(e, 'Select_City', isDropOffChrg || isPickUpChrg ? '' : 'dropOffCharge', () => {})
            }}
            onClick={saveAndUpdateCharg}
          >
            {isUpdate ? 'UPDATE' : 'SAVE'}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}
